import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const CircularIndeterminate = () => {
  return (
    <Box sx={{ m: 2 }}>
      <CircularProgress />
    </Box>
  );
};

export default CircularIndeterminate;
